import { Injectable, Injector } from '@angular/core';
import { BaseHolding, IdentifiersMap } from '@ddt-web/domain';
import { StoreService } from '@ddt-web/store-service';
import { PortfolioSecurityIdentifierMappingUtil } from '@ddt-web/wealth-web';

import { ApiParamsService } from '../../services/api-params.service';


@Injectable({
	providedIn: 'root'
})
export class PasApiParamsService extends ApiParamsService {
	constructor(private injector: Injector) {
		super(injector.get(StoreService));
	}

	protected createPosition(holding: BaseHolding, useValues: boolean): IdentifiersMap {
		let positionParam = super.createPosition(holding, useValues);

		positionParam['morningstarSecId'] = holding.morningstarSecId;
		positionParam['globalId'] = holding.globalId;
		positionParam['aladdinId'] = holding.aladdinId;
		positionParam['cusip'] = holding.cusip;
		positionParam['aladdinPortfolioCode'] = holding.aladdinPortfolioCode;
		positionParam['isin'] = holding.isin;
		positionParam['tpmId'] = holding.tpmId;


		positionParam = PortfolioSecurityIdentifierMappingUtil.setAladdinIdForCashAndIndex(holding, positionParam);

		return positionParam;
	}
}
